<template>
  <div>
    <div class="layout">
      <Menu active-key="1" @on-select="onSelect">
        <Menu-group title="業務介紹">
          <Menu-item key="1" name="one">
            1. 商戶名稱及標識
          </Menu-item>
          <Menu-item key="2" name="two">
            2. 商品或服務描述
          </Menu-item>
          <Menu-item key="3" name="three">
            3. 網上交易流程描述
          </Menu-item>
          <Menu-item key="4" name="four">
            4. 消費者客戶服務聯繫資訊
          </Menu-item>
          <Menu-item key="5" name="five">
            5. 退貨、退款和交易取消政策
          </Menu-item>
          <Menu-item key="6" name="six">
            6. 送貨政策
          </Menu-item>
          <Menu-item key="7" name="seven">
            7. 交易貨幣及支付方式（如銀聯、PayPal等）
          </Menu-item>
          <Menu-item key="8" name="eight">
            8. 售後服務或糾紛處理方式
          </Menu-item>
          <Menu-item key="9" name="nine">
            9. 保密聲明或隱私聲明政策
          </Menu-item>
        </Menu-group>
      </Menu>
      <content class="content">
        <h2 id="one">1. 商戶名稱及標識</h2>
        <div class="denomination">
          <div class="title">药跨境</div>
          <div><img src="/assets/pc/images/home/live-logo.jpg" alt="" /></div>
        </div>
        <h2 id="two">2. 商品或服務描述</h2>
        <div>
          國際藥品跨境線上交易平台
        </div>
        <h2 id="three">3. 網上交易流程描述</h2>
        <div>
          先登錄帳戶，把藥品加入購物車，在購物車中確認信息，上传处方及身份证件（若药品为处方药），经过平台药师审核通过后，選擇付款方式：微信支付，支付宝支付，線下支付，點擊確認付款，點擊後將替換微信支付二維碼頁面，支付宝二维码页面或聯繫客服提供線下支付憑證。
        </div>
        <h2 id="four">4. 消費者客戶服務聯繫資訊</h2>
        <div>
          <p>联系电话：00853 65885387</p>
          <p>地址：澳門电厂巷22號亨達大廈地下AJ座</p>
        </div>
        <h2 id="five">5. 退貨、退款和交易取消政策</h2>
        <div>
          <p>
            取消訂單：當您的訂單完成付款後，相關訂單內容已經被商戶確認并发货，我們無法為您取消訂單內容。
          </p>
          <p>退貨：1.當您的訂單一經發貨並已在運輸途中後，我們不提供退貨。</p>
          <p>2.收到货后若非质量问题，我們不提供退貨。</p>
          <p>
            退款：當您的訂單在發貨前，發現有任何問題，可以在訂單處發起退款申請或當您的訂單被執業藥師審核不通過，我們會直接更換。
          </p>
        </div>
        <h2 id="six">6. 送貨政策</h2>
        <div>
          <p>
            由香港倉庫出庫，清關並發貨往深圳，由深圳中轉國內快遞送到客人指定地址。
          </p>
        </div>
        <h2 id="seven">7. 交易貨幣及支付方式（如銀聯、PayPal等）</h2>
        <div>
          <p>交易貨幣：人民幣（因汇率实际扣款会有略微波动）</p>
          <p>支付方式：微信支付，支付宝支付，線下支付</p>
        </div>
        <h2 id="eight">8. 售後服務或糾紛處理方式</h2>
        <div>
          <p>售後服務或糾紛處理可通過微信、QQ、Email或致電聯繫電話處理。</p>
        </div>
        <h2 id="nine">9. 保密聲明或隱私聲明政策</h2>
        <div>
          <p>
            药跨境保障任何使用本平台页面的人員的私隱權。我們會確保所收集的個人資料僅用於清關及資料審核，我們對個人資料進行保密，對提供的資質材料進行用完即毀，不用作一切商業行為。
          </p>
        </div>
      </content>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpCenter",
  data() {
    return {};
  },
  methods: {
    onSelect(name) {
      document.querySelector("#" + name).scrollIntoView();
    }
  }
};
</script>

<style lang="stylus" scoped>
.layout
  display flex
  background #fff
  .content
    margin 0 20px
    padding-bottom 20px
    width 100%
    font-size 16px
    .denomination
      text-align center
      .title
        font-size 14px
    div
      font-size 14px
    h2
      margin-top 20px
</style>
